import React, { useEffect, useState } from "react";
import { Text, Flex, PaperclipIcon } from "@fluentui/react-northstar";
import TextArea from "antd/lib/input/TextArea";
import AnnotationSystem from "../AnnotationSystem";
import { useIntelligentGrading } from "../../../../../../context/useIntelligentGrading";

const AttchedFiles = ({ files, isAnnotationMode }) => {
  const { annotations, setAnnotations } = useIntelligentGrading();

  const index = annotations.findIndex(
    (annotation) => annotation.id === files.id
  );

  const onAnnotationAdd = (annotation) => {
    let clonedAnnotations = [...annotations];
    if (index === -1) {
      clonedAnnotations.push({ id: files.id, annotations: [annotation] });
    } else {
      clonedAnnotations[index].annotations.push(annotation);
    }
    setAnnotations(clonedAnnotations);
  };

  const onAnnotationDelete = (id) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.filter((annotation) => annotation.id !== id);
    setAnnotations(clonedAnnotations);
  };
  const onAnnotationEdit = (id, comment) => {
    let clonedAnnotations = [...annotations];
    clonedAnnotations[index].annotations = clonedAnnotations[
      index
    ].annotations.map((annotation) =>
      annotation.id === id ? { ...annotation, comment } : annotation
    );
    setAnnotations(clonedAnnotations);
  };
  // Helper to extract file name from URL
  const getFileName = (url) => {
    try {
      return decodeURIComponent(url.split("/").pop());
    } catch {
      return url;
    }
  };

  return (
    <div>
      <Flex gap="gap.small" column>
        <Flex column gap="gap.small">
          <Text content="File Attachment Analysis" weight="semibold" />
          <Flex column gap="gap.small">
            {Array.isArray(files.info) && files.info.length > 0 ? (
              files.info.map((file, idx) => {
                // Support both string and array in file.info
                const url = file;
                const fileName = getFileName(url);
                return (
                  <div
                    style={{
                      border: "1px solid #e0e0e0",
                      background: "#f9fafb",
                      borderRadius: "10px",
                      padding: "16px",
                    }}
                  >
                    <Flex column gap="gap.small">
                      <Flex gap="gap.smaller" vAlign="center">
                        <PaperclipIcon outline />
                        <Text
                          content={fileName}
                          weight="semibold"
                          size="large"
                        />
                      </Flex>
                      {/* <Flex column gap="gap.small">
                        <Text content={"Extracted Text:"} weight="semibold" />
                        <TextArea rows={4} readOnly />
                      </Flex> */}
                    </Flex>
                  </div>
                );
              })
            ) : (
              <Text content="No files attached." />
            )}
          </Flex>
        </Flex>

        <Flex column gap="gap.small">
          <Text content="Attachment Content" weight="semibold" />
          <AnnotationSystem
            isAnnotationMode={isAnnotationMode}
            essayText={files.extractedText}
            annotations={annotations?.[index]?.annotations || []}
            onAnnotationAdd={onAnnotationAdd}
            onAnnotationDelete={onAnnotationDelete}
            onAnnotationEdit={onAnnotationEdit}
          />
        </Flex>
      </Flex>
    </div>
  );
};

export default AttchedFiles;
